import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const PrescriptionApi = createApi({
  reducerPath: "PrescriptionApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["PRESCRIPTIONAPI"],
  endpoints: (build) => ({
    getPrescription: build.query({
      query: ({ page, searchTerm, userId, orgId }) => ({
        url: `/prescription?page=${page}&search=${searchTerm}&userId=${userId}&orgId=${orgId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRESCRIPTIONAPI"],
    }),
    getPrescriptionByUserId: build.query({
      query: ({ userId }) => ({
        url: `/prescription/${userId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRESCRIPTIONAPI"],
    }),
    getPrescriptionById: build.query({
      query: ({ id }) => ({
        url: `/prescription/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRESCRIPTIONAPI"],
    }),

    editPrescription: build.mutation({
      query: ({ id, data }) => ({
        url: `/prescription/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["PRESCRIPTIONAPI"],
    }),

    addPrescription: build.mutation({
      query: ({ data }) => ({
        url: `/prescription`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["PRESCRIPTIONAPI"],
    }),

    deletePrescription: build.mutation({
      query: ({ id }) => ({
        url: `/prescription/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRESCRIPTIONAPI"],
    }),
  }),
});

export const {
  useGetPrescriptionQuery,
  useGetPrescriptionByIdQuery,
  useEditPrescriptionMutation,
  useAddPrescriptionMutation,
  useDeletePrescriptionMutation,
  useGetPrescriptionByUserIdQuery,
} = PrescriptionApi;
